import React from 'react'
import {
  Layout,
  Icon,
  Menu,
  Dropdown,
  Avatar,
  Input,
  List,
  message,
  Spin,
  Tooltip,
  Button,
  Popover,
  Divider
} from 'antd'
import { withRouter, Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import DownloadFtXModal from '../../components/DownloadFtXModal'

import Share from '../../components/FilesShare/share'
import MediaInfo from '../../components/MediaInfo'

import sideThumb from '../../assets/img/icon/sideThumb.png'
// import logo from '../../assets/logo/wasabi_header_logo_light_v2.png'
import logo from '../../assets/logo/amove-light-logo.svg'

import { is_supported_video_format } from '../../utils'
import CloudFlyerAPI from '../../api/CloudFlyerAPI'
import { play_file } from '../../actions/video-player'
import { ReactComponent as Logo } from '../../assets/svg/user.svg';

import NavigationItems from '../Header/NavigationItems/navigationItems';

import './styles.scss'

class commonHeader extends React.Component {
  constructor() {
    super()

    this.state = {
      siderCollapsed: false,
      showFtXDownload: false,
      searchKeyword: '',
      visibleSearch: false,
      loading: false,
      current: 'mail',
    }
  }

  openFtXModal = () => {
    const { showFtXDownload } = this.state
    if (!showFtXDownload) {
      this.setState({ showFtXDownload: true })
    }
  }

  closeFtXModal = () => this.setState({ showFtXDownload: false })

  onToggle = () => {
    this.setState({
      siderCollapsed: !this.props.siderCollapsed,
    })
    this.props.onToggle()
  }

  on_menu_click = ({ key }) => {
    if (key === 'logout') return this.props.history.replace('/login')
    this.props.history.replace(key)
  }

  toggleSearch = () =>
    this.setState(({ visibleSearch }) => ({
      visibleSearch: !visibleSearch,
    }))

  onSearchOpen = () => {
    this.setState({ visibleSearch: true })
  }

  onSearchClose = () => {
    this.setState({ visibleSearch: false })
  }

  onSearch = e => {
    const value =
      (e.target && e.target.value) || e.target.value === '' ? e.target.value : e
    this.setState({ searchKeyword: value, visibleSearch: true })
  }

  setLoading = loading => {
    this.setState({ loading })
  }

  handleClick = e => {
    console.log('click ', e);
    this.setState({ current: e.key });
  };

  render() {
    const { profile, play_file } = this.props
    const {
      showFtXDownload,
      searchKeyword,
      visibleSearch,
      loading,

    } = this.state

    const {
      email: username = '',
      email = '',
      firstname = ' ',
      lastname = ' '
    } = profile.user || {}

    const menu = (
      <Menu
        className={'setting-menu'}
        selectedKeys={[]}
        onClick={this.on_menu_click}
      >
        {/* <Menu.Item key={'/profile'}>
          <Icon type="setting" />
          Profile
        </Menu.Item> */}

        {/* <Menu.Item key={'/users'}>
          <Icon type="setting" />
          Account
        </Menu.Item> */}

        {/* <Menu.Item key={'/tboard'}>
          <Icon type="dashboard" />
          Transfers status
        </Menu.Item> */}

        <Menu.Divider />
        <Menu.Item key={'logout'}>
          <Icon type="logout" />
          LogOut
        </Menu.Item>

        {/* <Menu.Item key={'/billing'}>
          <Icon type="setting" />
          Billing Details
        </Menu.Item> */}
      </Menu>
    )


     let navigationItems = [
        {key:1, label:"Dashboard", link: "/"},
        {key:2, label:"Account", link: "/admindaccount"},
        {key:3, label:"User", link: "/userList"},
        {key:4 ,label:"Replication Report", link: "/syncReport"},
        {key:5, label:"Transfer Report", link: "/transferReport"},
        {key:6, label:"Notifications", link: "/notifications"},
        {key:7, label:"Migration", link: "/migration"},
      ]


    const { current } = this.state;

    // const headerMenu = (

    // )

    return (
      <Layout.Header className="header_comp noselect">
        {/* <a className="sideThumb" onClick={this.props.onToggle}>
                    <img src={sideThumb} />
                    </a>


        <Icon
                    type="search"
                    className="search"
                    onClick={this.toggleSearch}
                    /> */}

        {/* <div className="search-input-container">
          <Popover
            arrowPointAtCenter={false}
            content={
              <SearchDropdown
                searchKeyword={searchKeyword}
                onClose={this.onSearchClose}
                play_file={play_file}
                setLoading={this.setLoading}
              />
            }
            trigger="click"
            placement="bottomRight"
            overlayClassName={'search-popover'}
            visible={searchKeyword !== '' && visibleSearch}
            onVisibleChange={visible => {
              if (!visible) this.onSearchClose()
              else this.onSearchOpen()
            }}
          >
            <Input
              className="search-input"
              placeholder="Search ... "
              prefix={
                (searchKeyword === '' || !visibleSearch) && (
                  <Icon type="search" />
                )
              }
              suffix={
                searchKeyword !== '' &&
                visibleSearch && <Icon type={loading ? 'loading' : 'search'} />
              }
              value={searchKeyword}
              onChange={this.onSearch}
            />
          </Popover>
        </div> */}
        <div className="logo-wrapper">
          <a className="logo" href={"/"}>
            <img src={logo} />
          </a>
          {/* <div className="vertical-divider"></div> */}
          {/* <h3 className="title">Wasabi Bucket Replication Manager</h3> */}
        </div>

        <div className="menu-wrapper">
          <NavigationItems navLinks={navigationItems}></NavigationItems>
        </div>

        <div className="widgets-wrapper">

        <p className="header-user-name">Hi, {firstname.charAt(0).toUpperCase( )+ firstname.slice(1)}</p>

            {/* <DownloadFtXModal
              visible={showFtXDownload}
              onClose={this.closeFtXModal}
            /> */}

            {/* <Icon type="down" /> */}
            <Dropdown overlay={menu} className="user-droppanel">
              <span className={'action'}>
                <Logo className="header-user-icon"/>
                {/* <Avatar style={{ verticalAlign: 'middle' }} alt="">
                  {' '}
                  {firstname.charAt(0).toUpperCase() +
                    ' ' +
                    lastname.charAt(0).toUpperCase()}
                </Avatar> */}
              </span>
            </Dropdown>
        </div>

      </Layout.Header>
    )
  }
}

class SearchDropdown extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      keyword: '',
      files: [],
      loading: false,
      hovered: '',
      dl_loading: false,
      download_files: [],
      share_visible: false,
      share_select_all: false,
      share_files: [],
      share_loading: false,
      slack_channels: [],
      slack_channel: '',
      share_on_slack: '',
      share_recipients: [],
      share_expiration: 604800,
      share_password: '',
    }
  }

  componentWillReceiveProps(nextProps) {
    const { searchKeyword } = nextProps
    if (searchKeyword != this.props.searchKeyword)
      this.setState({ keyword: searchKeyword }, this.timeOutSearch)
  }

  onMouseOver = item => {
    this.setState({ hovered: item.full_path })
  }

  onMouseLeave = () => {
    this.setState({ hovered: '' })
  }

  timeOutSearch = () => {
    const { keyword } = this.state
    clearTimeout(this.tm)
    this.tm = setTimeout(() => this.onSearch(keyword), 500)
  }

  onSearch = keyword => {
    const { setLoading } = this.props
    setLoading(true)
    this.setState({ keyword, loading: true })
    CloudFlyerAPI.storages
      .search({ keyword, config: { limit: 10 } })
      .then(({ data: { count = 0, results = [] } = {} }) =>
        this.setState(
          {
            files: results.filter(
              _ => _.type === 'FS_FILE_TYPE_FILE' && _.name.length < 50
            ),
            loading: false,
          },
          () => setLoading(false)
        )
      )
      .catch(err => {
        console.error(err)
        this.setState({ loading: false }, () => setLoading(false))
        message.error(err.message)
      })
  }

  on_download = file => {
    this.setState({ dl_loading: true })

    CloudFlyerAPI.transfer
      .download_url(file.cloud_account_id, file.bucket_name, [file.file_key])
      .then(res => {
        this.setState({ dl_loading: false })
        if (!((res || {}).data || {})) {
          return message.error(
            'failed to generate download link, please retry again'
          )
        }
        this.setState({ download_files: (res || {}).data || [] })
      })
      .catch(err => {
        this.setState({ dl_loading: false })
        message.error(err)
      })
  }

  on_share = file => {
    file.share = true
    file.basename = file.file_key

    this.props.onClose()

    this.setState({
      share_visible: true,
      share_select_all: true,
      share_files: [file],
    })
  }

  on_share_files = files => {
    const { share_recipients, share_password, share_expiration } = this.state
    this.setState({ share_loading: true })

    let share_files = []

    for (let key in files) {
      share_files.push({
        name: files[key].file_key,
        size: files[key].size,
        acl: 'private',
        bucket_name: files[key].bucket_name,
        cloud_account_id: files[key].cloud_account_id,
      })
    }

    if (share_files.length <= 0 || share_recipients.length <= 0) return

    CloudFlyerAPI.transfer
      .share_by_email_files({
        files: share_files,
        recipients: share_recipients,
        password: share_password,
        expiration: share_expiration,
      })
      .then(() => {
        this.setState({
          share_visible: false,
          share_loading: false,
        })
        message.success('files shared successfully')
      })
      .catch(err => {
        this.setState({ share_loading: false })
        message.error(err.message)
      })
  }

  on_recipient_change = recipients => {
    this.setState({ share_recipients: recipients })
  }

  on_share_password_change = ({ target }) =>
    this.setState({ share_password: target.value })

  on_share_expiration_change = value =>
    this.setState({ share_expiration: value })

  on_share_select_all = check_all => {
    for (let key in this.state.files) {
      this.state.files[key].share = check_all
    }

    this.setState({
      files: this.state.files,
      share_select_all: check_all,
    })
  }

  on_share_cancel = () => {
    this.setState({ share_visible: false })
  }

  on_share_select = (file, share) => {
    for (let key in this.state.share_files) {
      let item = this.state.share_files[key]
      if (item.basename === file.basename) {
        item.share = share
        this.setState({
          share_files: this.state.share_files,
          share_select_all: false,
        })
        return
      }
    }
  }

  on_copy_link = file => {
    if (!file) {
      return
    }

    try {
      let textArea = document.createElement('textarea')
      textArea.style.position = 'fixed'
      textArea.style.top = 0
      textArea.style.left = 0
      textArea.style.width = '2em'
      textArea.style.height = '2em'
      textArea.style.padding = 0
      textArea.style.border = 'none'
      textArea.style.outline = 'none'
      textArea.style.boxShadow = 'none'
      textArea.style.background = 'transparent'
      textArea.value = file.download_url
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
    } catch (e) {}

    message.success('Link copied!')
  }

  on_generate_link = (file, hide_message) => {
    file.generating_link = true

    CloudFlyerAPI.transfer
      .download_url(file.cloud_account_id, file.bucket_name, [file.file_key])
      .then(response => {
        file.generating_link = false

        if (!(response || {}).data) {
          return message.error(
            'failed to generate download link, please retry again'
          )
        }

        file.download_url = (response || {}).data[0].url
        this.setState({ files: this.state.files })

        if (!hide_message) message.success('Link generated !')
      })
      .catch(err => {
        file.generating_link = false
        file.download_url = null
        this.setState({ files: this.state.files })
        message.error(err)
      })
  }

  on_show_media_info = file => {
    this.props.onClose()

    file.basename = file.path = file.file_key
    this.media_info.open({
      ...file,
      ...{
        bucket_name: file.bucket_name,
        cloud_account_id: file.cloud_account_id,
      },
    })
  }

  on_copy_dll = async file => {
    if (!file) {
      return
    }

    if (!file.download_url)
      return (file.download_url = (await CloudFlyerAPI.transfer.download_url(
        file.cloud_account_id,
        file.bucket_name,
        [file.file_key]
      )).data[0].url)
    this.on_copy_link(file)
  }

  on_play = file => {
    this.props.play_file(file.cloud_account_id, file.bucket_name, file.file_key)
  }

  render() {
    const { searchKeyword, onClose } = this.props
    let {
      files,
      loading,
      hovered,
      download_files,
      share_files,
      share_visible,
      share_select_all,
      share_loading,
      slack_channels,
      slack_channel,
      share_on_slack,
      share_recipients,
      share_expiration,
      share_password,
    } = this.state
    files = files.map(f => {
      return { ...f, file_key: f.key, key: f.full_path }
    })
    console.log('files : ', files)
    return (
      <div className="search-dropdown" onMouseLeave={this.onMouseLeave}>
        {/*<div className="search-head">
          <p className="">{`Searching for "${searchKeyword}"`}</p>
          <div className="close" />
    </div>*/}
        {/*files.length !== 0 && (
          <div className="files-count">{`${files.length} files found`}</div>
        )*/}
        <div className="content">
          {files.length ? (
            <List
              dataSource={files}
              renderItem={item => (
                <List.Item
                  onMouseOver={() => this.onMouseOver(item)}
                  key={item.full_path}
                >
                  <div
                    className={`details ${hovered === item.full_path &&
                      'hide-details'}`}
                  >
                    <div className="file-name">{item.name}</div>
                    <div classNam="bucket-name">{item.project_name} > {item.bucket_name}</div>
                  </div>
                  {hovered === item.full_path && (
                    <div className={`actions `}>
                      <Tooltip placement="bottom" title="Download">
                        <Button
                          ghost
                          type="primary"
                          shape="circle"
                          icon="download"
                          size="small"
                          onClick={() => this.on_download(item)}
                        />
                      </Tooltip>
                      <Tooltip placement="bottom" title="Share">
                        <Button
                          ghost
                          type="primary"
                          shape="circle"
                          icon="share-alt"
                          size="small"
                          onClick={() => this.on_share(item)}
                        />
                      </Tooltip>
                      <Tooltip placement="bottom" title="Show details">
                        <Button
                          ghost
                          type="primary"
                          shape="circle"
                          icon="info"
                          size="small"
                          onClick={() => this.on_show_media_info(item)}
                        />
                      </Tooltip>
                      <Tooltip placement="bottom" title="Copy download link">
                        <Button
                          ghost
                          type="primary"
                          shape="circle"
                          icon="copy"
                          size="small"
                          onClick={() => this.on_copy_dll(item)}
                        />
                      </Tooltip>

                      {is_supported_video_format(item.file_key) && (
                        <Tooltip
                          placement="bottom"
                          title={item.play ? 'Close video' : 'Play video'}
                        >
                          <Button
                            ghost
                            type="primary"
                            shape="circle"
                            icon={item.play ? 'close' : 'play-circle-o'}
                            size="small"
                            onClick={() => this.on_play(item)}
                          />
                        </Tooltip>
                      )}
                    </div>
                  )}
                </List.Item>
              )}
            />
          ) : (
            <div className="no-results">No results.</div>
          )}
          {share_visible && (
            <Share
              files={share_files}
              recipients={share_recipients}
              visible={share_visible}
              select_all={share_select_all}
              loading={share_loading}
              password={share_password}
              expiration={share_expiration}
              channels={[]}
              channel={''}
              share_on_slack={''}
              use_weblink={false}
              on_channel_change={''}
              on_cancel={this.on_share_cancel}
              on_select={this.on_share_select}
              on_copy_link={this.on_copy_link}
              on_generate_link={this.on_generate_link}
              on_share_files={this.on_share_files}
              on_recipient_change={this.on_recipient_change}
              on_password_change={this.on_share_password_change}
              on_expiration_change={this.on_share_expiration_change}
              on_select_all={this.on_share_select_all}
            />
          )}
          <div style={{ display: 'none' }}>
            {(download_files || []).map((file, i) => (
              <iframe key={i} download={file.url} src={file.url} />
            ))}
          </div>
          <MediaInfo ref={n => (this.media_info = n)} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = store => store

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      play_file,
    },
    dispatch
  )

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(commonHeader)
)
